import { React, useEffect, useState, } from 'react';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import CloseIcon from '@mui/icons-material/Close';


// material
import {
    Card,
    IconButton,
    Stack,
    Button,
    TextField,
    Divider,
    FormControl,
    MenuItem,
    InputLabel, Select,
    Autocomplete,
    Tooltip,
    Modal,
    Box,
    Tabs,
    Tab,
    Typography,
    Grid,
    FormHelperText
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { startOfMonth, endOfMonth, format } from 'date-fns';
import { useSnackbar } from 'notistack';
import Moment from 'moment';
import { Icon } from '@iconify/react';
import * as XLSX from 'xlsx';
import Iconify from '../../Iconify';
import URLS from '../../../services/urls.service';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import Page from '../../Page';
import { handleError } from '../../Common/Utils';
import AppCache from '../../../services/AppCache';
import CustomDataGrid from '../../Common/CustomDataGrid';
import TextAreaWithToolbar from '../../Common/TextAreaWithToolbar';
import { styled } from '@mui/material/styles';

// ----------------------------------------------------------------------


// ----------------------------------------------------------------------
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const style = {
    position: 'absolute',
    top: '50%',
    justifyContent: 'center',
    left: '50%',
    transform: 'translate(-50%, -50%)',

    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 10,
    p: 4,
};
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 1,
    maxHeight: '80vh',
    overflow: 'auto',
    borderRadius: '8px',
};

const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text
        .replace(/&nbsp;/gi, " ")   // handle literal &nbsp;
        .replace(/\u00A0/g, " ")   // replace non-breaking space
        .replace(/\s+/g, " ")      // collapse whitespace
        .trim();
};

const tmpCache = {
    effectiveFromValue: null,
    effectiveToValue: null,
    trackerMasterId: null,
    issueId: null,
    userId: null,
};
let shouldReload = false;
export default function ServiceRequestBDTrackerListingPage({ trackerMasterId, trackerName, allowAdd, allowEdit, allowDelete, trackerId }) {

    console.log("trackerMasterId>>>>>>>>>>>>>>>>", trackerMasterId, "trackerId", trackerId)
    const historyGridData = [
        {
            field: 'EditedDateTime',
            headerName: 'Edited Date Time',
            width: 150, // Explicit width
        },
        {
            field: 'EditedBy',
            headerName: 'Edited By',
            width: 130, // Explicit width
        },
        {
            field: 'ChangeDetails',
            headerName: 'Description',
            width: 300, // Explicit width
            renderCell: (params) => {
                let changeDetails = params.value;

                if (!changeDetails?.trim()) return <span>-</span>;

                if (changeDetails.includes('{IsResolvedBySupportTeam}')) {
                    changeDetails = changeDetails.split(' To ')[1]?.replace(/[()]/g, '') || changeDetails;
                }
                // Replace {} with <strong> and () with <em>
                const formattedText = changeDetails
                    .replace(/{([^}]+)}/g, (_, p1) => `<strong>${p1}</strong>`)
                    .replace(/\(([^)]+)\)/g, (_, p1) => `<em>${p1}</em>`);

                return (
                    <span
                        style={{ fontFamily: 'Inter, sans-serif' }}
                        dangerouslySetInnerHTML={{ __html: formattedText }}
                    />
                );
            },
        }

    ];

    const linkedHitoryColumn = [
        {
            field: 'EditedDateTime',
            headerName: 'Edited Date Time',
            width: 150, // Explicit width
        },
        {
            field: 'EditedBy',
            headerName: 'Edited By',
            width: 130, // Explicit width
        },
        {
            field: 'ChangeDetails',
            headerName: 'Description',
            width: 300, // Explicit width
            renderCell: (params) => {
                let changeDetails = params.value;

                if (!changeDetails?.trim()) return <span>-</span>;

                if (changeDetails.includes('{IsResolvedBySupportTeam}')) {
                    changeDetails = changeDetails.split(' To ')[1]?.replace(/[()]/g, '') || changeDetails;
                }
                // Replace {} with <strong> and () with <em>
                const formattedText = changeDetails
                    .replace(/{([^}]+)}/g, (_, p1) => `<strong>${p1}</strong>`)
                    .replace(/\(([^)]+)\)/g, (_, p1) => `<em>${p1}</em>`);

                return (
                    <span
                        style={{ fontFamily: 'Inter, sans-serif' }}
                        dangerouslySetInnerHTML={{ __html: formattedText }}
                    />
                );
            },
        }

    ];

    const documentHistoryGridData = [
        {
            field: 'DateTime',
            headerName: 'Edited Date Time',
            width: 150, // Explicit width
        },
        {
            field: 'Name',
            headerName: 'Edited By',
            width: 130, // Explicit width
        },
        {
            field: 'ChangeDetails',
            headerName: 'Description',
            width: 300,
            renderCell: (params) => {
                const changeDetails = params.value;
                if (!changeDetails?.trim()) return <span>-</span>;

                const downloadFile = (fileName) => {
                    const encodedKey = encodeURIComponent(fileName);

                    URLS.downloadServiceFileByName(encodedKey, { responseType: "blob" })
                        .then((response) => {
                            if (response.status === 200) {

                                const requestUrl = response.request.responseURL;

                                const link = document.createElement("a");
                                link.href = requestUrl;
                                link.setAttribute("download", fileName);
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                enqueueSnackbar("File downloaded successfully.", { variant: "success" });
                            } else {
                                enqueueSnackbar("Failed to download file.", { variant: "error" });
                            }
                        })
                        .catch(() => {
                            enqueueSnackbar("File not found.", { variant: "error" });
                        });
                };

                const cleanText = stripHtml(changeDetails);

                const parts = cleanText.split(/(\{[^}]+\}|\((?:[^()]+|\([^()]*\))*\))/g);

                let lastBoldText = "";

                return (
                    <span style={{ fontFamily: "Inter, sans-serif" }}>
                        {parts.map((part, index) => {

                            if (part.startsWith("{") && part.endsWith("}")) {
                                const boldText = part.slice(1, -1);
                                lastBoldText = boldText;

                                return <strong key={index}>{boldText}</strong>;
                            }

                            if (part.startsWith("(") && part.endsWith(")")) {
                                const value = part.slice(1, -1);

                                if (lastBoldText === "RefrenceDocument") {
                                    return (
                                        <span key={index}>
                                            <em>
                                                <a
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        downloadFile(value);
                                                    }}
                                                    style={{
                                                        color: "blue",
                                                        textDecoration: "underline",
                                                        cursor: "pointer"
                                                    }}
                                                >
                                                    {value}
                                                </a>
                                            </em>
                                        </span>
                                    );
                                }

                                return <em key={index}>{value}</em>;
                            }

                            return part;
                        })}
                    </span >
                );
            },
        }
    ];

    const [tabValue, setTabValue] = useState(0);

    const { enqueueSnackbar } = useSnackbar();
    const location = useLocation();
    const navigate = useNavigate();

    const [historyData, setHistoryData] = useState([]);
    const [documentHistoryData, setDocumentHistoryData] = useState([]);

    const [pageSize, setPageSize] = useState(25);
    const [pageSize2, setPageSize2] = useState(25);


    const [effectiveFromValue, setEffectiveFromValue] = useState(tmpCache.effectiveFromValue ?? startOfMonth(new Date()));
    const [effectiveToValue, setEffectiveToValue] = useState(tmpCache.effectiveToValue ?? endOfMonth(new Date()));
    const [reports, setReports] = useState([]);
    const [columns, setColumns] = useState([])
    const [filteredReports, setFilteredReports] = useState([]); // Filtered data

    const [isLoading, setIsLoading] = useState();
    const [issueId, setIssueId] = useState('');
    const [editData, setEditData] = useState([])
    const [open, setOpen] = useState(false);

    const [historyOpen, setHistoryOpen] = useState(false);
    const [documentHistoryOpen, setDocumentHistoryOpen] = useState(false);

    const [reopenModal, setReopenModal] = useState(false);
    const [selectedReopenRow, setSelectedReopnRow] = useState(null);

    const [selectedRow, setSelectedRow] = useState(null);
    const [deleteRowId, setDeleteRowId] = useState('');

    const [lagInterval, setLagInterval] = useState('');

    const [lageIntervalddl, setLagIntervalddl] = useState(tmpCache.lageIntervalddl ?? '');
    const [selectedLagIntervalddl, setSelectedLagIntervalddl] = useState(tmpCache.selectedLagIntervalddl ?? []);

    const [showDDL, setShowDDL] = useState(false);

    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const userId = CurrentLoggedInUser.ExecutiveId;
    const isSaplUser = CurrentLoggedInUser?.IsSaplUser;

    const [loadTrackerData, setLoadTrackerData] = useState(tmpCache.loadTrackerData ?? []);
    const [linkedIncidentId, setLinkedIncidentId] = useState(null);
    const [linkedHistoryData, setLinkedHistoryData] = useState([]);

    const [reopenConfirmModal, setReopenConfirmModal] = useState(false);
    const [reopenValue, setReopenValue] = useState([]);
    const [validationErrors, setValidationErrors] = useState({});
    const [fieldValues, setFieldValues] = useState({});
    const [reopenModalData, setReopenModalData] = useState([]);

    const [requestFile, setRequestFile] = useState([]);
    const [base64Document, setBase64Document] = useState([]); // New state for Base64 string
    const [uploadedFiles, setUploadedFiles] = useState(reopenModalData.FileKeys || []);
    const [reopenPrefill, setReopenPrefill] = useState({});


    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);

    };
    const handleEffFrom = (newValue) => {
        setEffectiveFromValue(newValue)
    };
    const handleEffTo = (newValue) => {
        setEffectiveToValue(newValue)
    };
    const handleReopenModal = (cellValues) => {
        // Set loading state to true when opening
        setSelectedReopnRow(cellValues);
        setReopenModal(true);

    };
    const handleReopenCloseModal = () => {
        // Set loading state to true when opening
        setSelectedReopnRow(null);

        setReopenModal(false);

    };
    const handleReopenConfirmCloseModal = () => {
        // Set loading state to true when opening
        setSelectedReopnRow(null);
        setValidationErrors({});
        setReopenConfirmModal(false);
        setReopenModal(false);

    };

    const handleConfirmReopen = () => {
        if (!selectedReopenRow) return;
        setIsLoading(true);
        shouldReload = true;
        const isReopen = selectedReopenRow?.row.Reopen
        console.log("selectedReopenRow", selectedReopenRow, selectedReopenRow.row, isReopen)
        URLS.editLoadData({ Id: selectedReopenRow.row.ID, TrackerMasterId: trackerId ?? trackerMasterId, })
            .then((response) => {
                const jsonDataString = JSON.stringify(response.data);

                const modifiedData = JSON.parse(jsonDataString);
                console.log("modifiedData", modifiedData)
                setEditData(modifiedData);

                //  setReopenConfirmModal(true);
                setReopenModalData(modifiedData);
                navigate('/dashboard/servicerequesttrackerdetailspage', { state: { tracker: modifiedData, trackerMasterId, loadTrackerData, trackerName, isReopen } })
                setIsLoading(false);

            })
            .catch(error => {
                // On error
                enqueueSnackbar("Record not found", { variant: 'success' });
                setIsLoading(false);

            });


    };

    const handleReopen = () => {
        const isReopen = selectedReopenRow?.row?.Reopen;

        setIsLoading(true);

        const currentErrors = {};

        const QuestionAnswersData = loadTrackerData.map((field) => {
            const fieldValue = fieldValues[field.Sequence];

            // Existing value from reopen data
            const preSelectedValue =
                reopenModalData?.DataTable?.[0]?.[field.ColumnName] ??
                field.DefaultValue ??
                "";

            // Resolve @LoginUser
            const resolvedDefaultValue =
                preSelectedValue === "@LoginUser"
                    ? userName
                    : preSelectedValue;

            const effectiveValue =
                isReopen && field.ColumnName === "Status"
                    ? "Reopen"
                    : fieldValue !== undefined &&
                        fieldValue !== null &&
                        fieldValue !== ""
                        ? fieldValue
                        : resolvedDefaultValue;

            const isFieldEmpty =
                field.IsCompulsory &&
                (
                    effectiveValue === undefined ||
                    effectiveValue === null ||
                    String(effectiveValue).trim() === ""
                );

            if (isFieldEmpty) {
                currentErrors[field.Sequence] =
                    `${field.DisplayName} is required`;
            }
            // Minimum 15 characters validation
            // Replace "SAPLComments" with your required ColumnName 
            // SAPLComments validation
            if (field.ColumnName === "SAPLComments") {
                const textValue = stripHtml(
                    String(effectiveValue ?? "")
                ).trim();

                console.log("SAPLComments validation:", {
                    fieldValue,
                    effectiveValue,
                    textValue,
                    length: textValue.length
                });

                if (!textValue) {
                    currentErrors[field.Sequence] =
                        `${field.DisplayName} is required`;
                } else if (textValue.length < 15) {
                    currentErrors[field.Sequence] =
                        `${field.DisplayName} must be minimum 15 characters`;
                }
            }
            let finalValue;

            // Status
            if (isReopen && field.ColumnName === "Status") {
                finalValue = "Reopen";
            }

            // Checkbox
            else if (field.UIControlKeyId === 5) {
                finalValue = fieldValue === true
                    ? "True"
                    : "False";
            }

            // Date
            else if (field.UIControlKeyId === 7) {
                finalValue =
                    fieldValue ||
                    resolvedDefaultValue ||
                    format(new Date(), "dd-MMM-yyyy");
            }

            // Other controls
            else {
                finalValue =
                    fieldValue !== undefined &&
                        fieldValue !== null &&
                        fieldValue !== ""
                        ? fieldValue
                        : (resolvedDefaultValue ?? field.Answers ?? "");
            }

            // Remove HTML for Rich Text / HTML control
            if (field.UIControlKeyId === 9) {
                finalValue = stripHtml(finalValue);
            }

            return {
                ColumnName: field.ColumnName,
                Value: finalValue,
            };
        });
        const hasFiles = Array.isArray(uploadedFiles) && uploadedFiles.length > 0;

        if (!hasFiles) {
            currentErrors.files = "Attachment is required";
        }
        console.log("QuestionAnswersData:", QuestionAnswersData);
        console.log("currentErrors:", currentErrors);

        setValidationErrors(currentErrors);

        if (Object.keys(currentErrors).length > 0) {
            console.log("Form has validation errors:", currentErrors);

            setIsLoading(false);
            return;
        }
        console.log("QuestionAnswersData:", QuestionAnswersData);
        console.log("currentErrors:", currentErrors);

        setValidationErrors(currentErrors);

        if (Object.keys(currentErrors).length > 0) {
            setIsLoading(false);
            return;
        }


        const currentId =
            reopenModalData?.DataTable?.[0]?.ID || 0;

        const formData = new FormData();

        formData.append("Id", currentId);
        formData.append("LoginId", userId);

        formData.append(
            "ServiceRequestId",
            reopenModalData?.DataTable?.[0]?.ServiceRequestId || 0
        );

        formData.append("Request", "");
        formData.append("ServiceRequestMappingColumn", "");
        formData.append("RefrenceDocument", "");

        formData.append(
            "TrackerMasterId",
            trackerMasterId
        );

        formData.append(
            "IsReopen",
            isReopen || 0
        );

        formData.append(
            "OldIncidentId",
            Number(isReopen) === 1
                ? currentId
                : 0
        );

        formData.append(
            "IsResolvedBySupportTeam",
            1
        );
        console.log("requestFile:", requestFile);
        console.log("requestFile length:", requestFile?.length);
        if (requestFile?.length > 0) {
            for (let i = 0; i < requestFile.length; i += 1) {
                formData.append(
                    "RequestDocument",
                    requestFile[i]
                );
            }
        }

        if (uploadedFiles?.length > 0) {
            const existingFileNames = uploadedFiles
                .filter(
                    (file) => typeof file === "string"
                )
                .map(
                    (filePath) =>
                        filePath.split("/").pop()
                )
                .join(",");

            if (existingFileNames) {
                formData.append(
                    "ExistingFiles",
                    existingFileNames
                );
            }
        }

        QuestionAnswersData.forEach((item, index) => {
            formData.append(
                `TrackerData[${index}].ColumnName`,
                item.ColumnName
            );

            formData.append(
                `TrackerData[${index}].Value`,
                item.Value ?? ""
            );
        });


        for (const [key, value] of formData.entries()) {
            console.log(key, value);
        }

        URLS.saveIssueTrackerData(formData)
            .then((response) => {
                console.log(
                    "API SUCCESS:",
                    response
                );

                setIsLoading(false);

                if (response.data) {
                    enqueueSnackbar("Record saved successfully", { variant: "success", });
                    onFilterClick();
                    handleReopenConfirmCloseModal();
                }
            })
            .catch((error) => {
                console.error(
                    "API ERROR:",
                    error
                );

                setIsLoading(false);

                enqueueSnackbar(
                    "Record not saved",
                    {
                        variant: "error",
                    }
                );
            });

        console.log("After API call");
    };

    const handleHistoryOpen = (cellValues) => {
        // Set loading state to true when opening
        setTabValue(0);
        setIsLoading(true);
        setHistoryOpen(true);

        console.log("cellValues", cellValues, cellValues.row)
        const payload = {
            TrackerMasterId: trackerMasterId,
            TrackerRequestId: cellValues.row.ID
        }

        URLS.editLoadData({ Id: cellValues.row.ID, TrackerMasterId: trackerId ?? trackerMasterId, })
            .then((response) => {
                const jsonDataString = JSON.stringify(response.data);

                const modifiedData = JSON.parse(jsonDataString);

                const parentId = modifiedData.DataTable?.[0]?.ParentIncidentId;
                const childId = modifiedData.DataTable?.[0]?.ChildIncidentId;

                // Show tab only when they are NOT equal
                // Pass parentId when valid, else null
                const linkedId = parentId !== childId ? parentId : null;
                setLinkedIncidentId(linkedId);
                console.log("modifiedData", modifiedData)

            })
            .catch(error => {
                // On error
                enqueueSnackbar("Record not found", { variant: 'success' });


            });

        URLS.serviceRequestTrackerHistory(payload)
            .then((response) => {
                console.log("res", response);
                setIsLoading(false); // Stop loading
                setHistoryData(response.data || []); // Set response data to historyData
            })
            .catch((error) => {
                console.error("Error loading tracker data:", error);
                setIsLoading(false); // Stop loading in case of error
                setHistoryData([]); // Clear historyData on error
            })

    };

    const handleDocumentHistoryOpen = (cellValues) => {
        // Set loading state to true when opening
        setIsLoading(true);
        setDocumentHistoryData([]);

        console.log("cellValues", cellValues, cellValues.row)
        const payload = {
            TrackerMasterId: trackerMasterId,
            TrackerRequestId: cellValues.row.ID
        }


        URLS.serviceRequestTrackerDocumentHistory(payload)
            .then((response) => {
                console.log("res", response);
                setIsLoading(false); // Stop loading
                setDocumentHistoryData(response.data || []); // Set response data to historyData
                setIsLoading(false);
                setDocumentHistoryOpen(true);
            })
            .catch((error) => {
                console.error("Error loading tracker data:", error);
                setIsLoading(false); // Stop loading in case of error
                setDocumentHistoryData([]); // Clear historyData on error
                setIsLoading(false);
                setDocumentHistoryOpen(true);
            })

    };

    const handleHistoryClose = () => {
        // Close history view and reset states
        setTabValue(0);
        setHistoryOpen(false);
        setHistoryData([]); // Clear the previous history data when closing
        setIsLoading(false); // Reset loading state when closing
        setLinkedHistoryData([]);
    };

    const handleDocumentHistoryClose = () => {
        // Close history view and reset states
        setDocumentHistoryOpen(false);
        setDocumentHistoryData([]); // Clear the previous history data when closing
        setIsLoading(false);
    };


    useEffect(() => {
        if (tabValue === 1 && linkedIncidentId) {
            URLS.serviceRequestTrackerHistory({
                TrackerRequestId: linkedIncidentId,
                TrackerMasterId: trackerMasterId,
            })
                .then((res) => setLinkedHistoryData(res.data || []))
                .catch((error) => {
                    console.error("Error loading tracker data:", error);
                    setLinkedHistoryData([]); // Clear historyData on error
                })
        }
    }, [tabValue, linkedIncidentId]);


    const generateColumns = (data) => {
        if (!data || data.length === 0) return [];
        const firstRow = data[0];

        // Generate dynamic columns, excluding "Reopen"
        const columns = Object.keys(firstRow)
            .filter((key) => key !== "Reopen" && key !== "IsEdit" && key !== "IsReopen" && key !== "ColorCode" && key !== "ServiceRequestId" && key !== "IsResolvedBySupportTeam") // hide Reopen column
            .map((key) => ({
                field: key,
                headerName: key
                    .replace(/([A-Z])/g, " $1")
                    .replace(/^./, (str) => str.toUpperCase()),
                width: 120,
                // Strip HTML for export + display
                valueGetter: (params) => {
                    const value = params.row[key];
                    return typeof value === "string"
                        ? stripHtml(value)
                        : value;
                },
                renderCell: (params) => {
                    const { value } = params;
                    const plainText =
                        typeof value === "string"
                            ? stripHtml(value)
                            : value;

                    return (
                        <Tooltip title={
                            <div
                                style={{
                                    maxHeight: "150px",   // height limit
                                    overflowY: "auto",    // vertical scrollbar
                                    whiteSpace: "pre-wrap",
                                    wordBreak: "break-word",
                                    paddingRight: "4px",
                                }}
                            >
                                {plainText}
                            </div>
                        }>
                            <div
                                style={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    width: "100%",
                                }}
                            >
                                {plainText}
                            </div>
                        </Tooltip>
                    );
                },
            }));


        const actionColumn = {
            field: 'actions',
            headerName: 'Actions',
            type: 'actions',
            width: 180,
            renderCell: (cellValues) => {
                const showReopen = cellValues.row.Reopen === 1; // Reopen flag from API
                const canEdit = cellValues.row.IsEdit === true;
                return (
                    <div
                        style={{
                            display: "flex",             // ✅ enable flexbox
                            justifyContent: "flex-end",  // ✅ align buttons to right
                            gap: "4px",                  // optional: spacing between buttons
                            width: "100%",               // take full cell width
                        }}
                    >
                        {showReopen && (
                            // Show only Reopen button
                            <Tooltip title="Reopen">
                                <IconButton
                                    onClick={() =>
                                        handleReopenModal({ ...cellValues, reopen: cellValues.row.Reopen })
                                    }
                                    color="default"
                                >
                                    <Iconify
                                        icon="humbleicons:restart"
                                        width="20px"
                                        height="20px"
                                        color="primary.main"
                                    />
                                </IconButton>
                            </Tooltip>
                        )}
                        {canEdit && (
                            <>
                                <Tooltip title="Edit">
                                    <IconButton
                                        onClick={(event) => handleClick(event, { ...cellValues, reopen: cellValues.row.Reopen, })}
                                        color="primary"
                                    >
                                        <Iconify
                                            icon="ic:outline-edit"
                                            width="20px"
                                            height="20px"
                                        />
                                    </IconButton>
                                </Tooltip>
                                {isSaplUser && (
                                    <Tooltip title="Delete">
                                        <IconButton
                                            onClick={() => handleDelete(cellValues)}
                                            color="secondary"
                                        >
                                            <Iconify
                                                icon="ic:baseline-delete"
                                                width="20px"
                                                height="20px"
                                                color="primary.main"
                                            />
                                        </IconButton>
                                    </Tooltip>
                                )}

                            </>
                        )}
                        {/* History is always shown */}
                        <Tooltip title="History">
                            <IconButton
                                onClick={() => handleHistoryOpen(cellValues)}
                                color="default"
                            >
                                <Iconify
                                    icon="mdi:clipboard-text-history-outline"
                                    width="20px"
                                    height="20px"
                                    color="primary.main"
                                />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Document History">
                            <IconButton
                                onClick={() => handleDocumentHistoryOpen(cellValues)}
                                color="default"
                            >
                                <Iconify
                                    icon="mdi:file-document-outline"
                                    width="20px"
                                    height="20px"
                                    color="primary.main"
                                />
                            </IconButton>
                        </Tooltip>
                    </div>
                );
            },
        };

        // Append the action column to the dynamic columns
        return [...columns, actionColumn];
    };

    const removeLastPipe = (val = "") => {
        if (typeof val !== "string") return val;

        // Replace double pipe (||) with comma
        return val
            .replace(/\s*\|\|\s*/g, ", ")
            .trim();
    };

    const processFilterData = (rows = [], trackerData = []) => {
        const col = [...trackerData]
            .reverse()
            .find(c => [8, 9].includes(c.UIControlKeyId));

        if (!col) return rows;

        return rows.map(row =>
            row[col.ColumnName]
                ? { ...row, [col.ColumnName]: removeLastPipe(row[col.ColumnName]) }
                : row
        );
    };

    const onFilterClick = () => {
        setIsLoading(true);
        const formDate = format(effectiveFromValue, 'dd-MMM-yyyy');
        const toDate = format(effectiveToValue, 'dd-MMM-yyyy');
        const lagPaylod = {
            "TrackerId": trackerId ?? trackerMasterId,
            "LagDaysInterval": lagInterval,
            "FromDate": formDate,
            "ToDate": toDate,
            "LoginId": userId
        };

        const payload = {
            FromDate: formDate,
            ToDate: toDate,
            IssueId: issueId ?? tmpCache.issueId ?? "",
            TrackerMasterId: trackerId ?? trackerMasterId,
            Id: userId
        }
        console.log("payload", payload)
        URLS.filterIssueTrackerData(payload)
            .then((response) => {
                const rawData = response.data?.DataTable || [];
                const data = processFilterData(rawData, loadTrackerData);

                setReports(data);
                setShowDDL(true);
                setColumns(generateColumns(data)); // Pass the data to generate columns
                setFilteredReports(data);
                setIsLoading(false);
                enqueueSnackbar("Records Fetched successfully", { variant: 'success' });
                console.log("data", data)

            })
            .catch(error => {
                // On error
                setReports([]);
                setShowDDL(false);
                setFilteredReports([]);
                enqueueSnackbar("Record not found", { variant: 'success' });
                setIsLoading(false);
            });
        if (lagInterval) {
            URLS.fetchServiceRequestLagDays(lagPaylod)
                .then((response) => {
                    console.log("res", response)
                    setSelectedLagIntervalddl(response.data)
                })
                .catch((error) => {
                    console.error("Error loading tracker data:");
                });
        }

    };

    const handleClick = (event, cellValues) => {
        console.log(cellValues.row.ID, "cellValues", cellValues, cellValues?.row.Reopen)
        setIsLoading(true);
        shouldReload = true;
        const isReopen = cellValues?.row.Reopen
        URLS.editLoadData({ Id: cellValues.row.ID, TrackerMasterId: trackerId ?? trackerMasterId, })
            .then((response) => {
                const jsonDataString = JSON.stringify(response.data);

                const modifiedData = JSON.parse(jsonDataString);
                console.log("modifiedData", modifiedData)
                setEditData(modifiedData);
                navigate('/dashboard/servicerequesttrackerdetailspage', { state: { tracker: modifiedData, trackerMasterId, loadTrackerData, trackerName, isReopen } })

            })
            .catch(error => {
                // On error
                enqueueSnackbar("Record not found", { variant: 'success' });
                setIsLoading(false);

            });
    }

    const handleDelete = (cellValues) => {
        console.log('Delete clicked', cellValues.row);
        setSelectedRow(cellValues.row); // Set the selected row data
        setDeleteRowId(cellValues.row.ID)
        setOpen(true); // Open the modal
    };


    const handleClose = () => {
        setOpen(false);
        setSelectedRow(null);
    };

    const handleConfirmDelete = (confirmed) => {
        console.log("confirmed", confirmed)
        if (confirmed !== null) {
            const payload = { ServiceId: selectedRow.ServiceRequestId, LogginUserId: userId, TrackerMasterId: trackerId ?? trackerMasterId, Id: deleteRowId };
            const formDate = format(effectiveFromValue, 'dd-MMM-yyyy');
            const toDate = format(effectiveToValue, 'dd-MMM-yyyy');
            const filterPayload = { FromDate: formDate, ToDate: toDate, IssueId: issueId, TrackerMasterId: trackerId ?? trackerMasterId, Id: userId }

            URLS.deleteIssueTrackerData(payload)
                .then((response) => {
                    console.log("response", response)
                    if (response.status === 200) {
                        enqueueSnackbar("Deleted data successfully", { variant: 'success' });
                        setOpen(false);


                        URLS.filterIssueTrackerData(filterPayload)
                            .then((response) => {
                                const rawData = response.data?.DataTable || [];
                                const data = processFilterData(rawData, loadTrackerData);

                                setReports(data);
                                setFilteredReports(data);
                                setIsLoading(false);
                                enqueueSnackbar("Records Fetched successfully", { variant: 'success' });
                            })
                            .catch(error => {
                                // On error
                                setReports([])
                                setFilteredReports([]);
                                enqueueSnackbar("Record not found", { variant: 'success' });
                                setIsLoading(false);

                            });

                        // Filter out the deleted row from the reports

                    }
                })
                .catch((error) => {
                    enqueueSnackbar("Failed to delete record", { variant: 'error' });
                    console.error(error);
                });
        }
    };

    const hanleLagInterval = (event) => {
        setLagInterval(event.target.value)
    }
    const handleLagDDL = (range) => {
        setLagIntervalddl(range);
        if (!range) {
            setFilteredReports(reports);
        } if (range.includes('+')) {
            const min = parseInt(range.replace('+', ''), 10);
            const filtered = reports.filter((report) => report.LagInterval > min);
            setFilteredReports(filtered);
        } else {
            const [min, max] = range.split('-').map(Number);

            const filtered = reports.filter(
                (report) => report.LagInterval >= min && report.LagInterval <= max
            );

            setFilteredReports(filtered);
        }
    };

    const handleReset = () => {
        setReports([]);
        setEffectiveFromValue(startOfMonth(new Date()));
        setEffectiveToValue(endOfMonth(new Date()));
        setFilteredReports([]);
        setShowDDL(false);
    }

    const onExportClick = (rowsToExport) => {
        // Exclude "Reopen" and "IsEdit" columns from the data
        const filteredReports = rowsToExport.map(({ Reopen, IsEdit, IsReopen, ColorCode, IsResolvedBySupportTeam, ServiceRequestId, ...rest }) => rest);
        const payload = {
            TrackerName: trackerName || "",
            Data: filteredReports
        };
        URLS.exportExcel(payload)
            .then((response) => {
                if (response.status === 200 && response.data && response.data.filepath) {
                    const link = document.createElement('a');
                    link.href = response.data.filepath;
                    link.setAttribute('download', '');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    enqueueSnackbar("Excel data downloaded successfully", { variant: 'success' });
                }
            })
            .catch((error) => {
                enqueueSnackbar("File not found", { variant: 'error' });
                setIsLoading(false);
            });
    };

    const handleField = (sequence, value) => {
        // Update the field value in the state
        const finalValue = value === "@LoginUser" ? userName : value;

        setFieldValues(prevState => ({
            ...prevState,
            [sequence]: finalValue
        }));

        // Clear validation error for the field if value is entered
        if (validationErrors[sequence] && value.trim() !== '') {
            setValidationErrors(prevErrors => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[sequence]; // Remove error for the specific field
                return updatedErrors;
            });
        }
    };

    const renderField = (fields) => {
        const { UIControlKeyId, DisplayName, Sequence, DefaultValue, IsEdit, ColumnName, IsCompulsory } = fields;
        const dataValues = fields?.DataValues ?? "";

        // Get the preselected value from tracker[0] using the ColumnName
        const trackerData = reopenModalData.DataTable?.[0] || []; // Ensure tracker[0] exists
        console.log("trackerData[ColumnName]:", trackerData[ColumnName]);

        const resolvedDefaultValue = DefaultValue === "@LoginUser" ? userName : DefaultValue;
        console.log("resolvedDefaultValue:", resolvedDefaultValue);

        const preSelectedValue = trackerData[ColumnName] || resolvedDefaultValue || '';

        console.log("preSelectedValue:", preSelectedValue);

        if (fieldValues[Sequence] === undefined && preSelectedValue) {
            console.log("Calling handleField with Sequence:", Sequence, "and value:", preSelectedValue);
            handleField(Sequence, preSelectedValue);
        }

        console.log("fieldValues[Sequence]:", fieldValues[Sequence]);
        // Error condition: if there is no field value and the preselected value is cleared
        // const hasError = IsCompulsory && (!fieldValues[Sequence] || fieldValues[Sequence].trim() === '');
        const hasError = IsCompulsory && (!fieldValues[Sequence] || stripHtml(fieldValues[Sequence]) === '');
        const errorMessage = hasError ? validationErrors[Sequence] : '';

        switch (UIControlKeyId) {
            case 1: // Label
                {
                    return (
                        <FormControl fullWidth margin="normal">
                            <InputLabel shrink>{DisplayName}</InputLabel>
                            <div>{preSelectedValue}</div>
                        </FormControl>
                    );
                }
            case 2: // TextField
                {
                    return (
                        <TextField
                            label={DisplayName}
                            fullWidth
                            size="small"
                            onChange={(e) => handleField(fields.Sequence, e.target.value)}
                            value={fieldValues[fields.Sequence] ?? preSelectedValue ?? ''}
                            disabled={!IsEdit}
                            error={!!errorMessage}
                            helperText={errorMessage}
                        />
                    );
                }
            case 3: // Dropdown/Select
                {

                    let options = [];

                    if (Array.isArray(dataValues)) {
                        // Case: DataValues is an array of { Id, Value }
                        options = dataValues.map(item => ({
                            id: item.Id,
                            name: item.Value
                        }));
                    } else if (typeof dataValues === "string" && dataValues.includes("Id:")) {
                        // Case: DataValues string with Id: and Name:
                        const regex = /Id:\s*(\d+),\s*Name:\s*([\w\s]+)/g;
                        const matches = Array.from(dataValues.matchAll(regex));
                        options = matches.map(match => ({
                            id: parseInt(match[1], 10),
                            name: match[2]
                        }));
                    } else if (typeof dataValues === "string") {
                        // Case: DataValues like [A|B|C]
                        const dataValuesMatch = dataValues.match(/\[([^[\]]+)\](?=[^[]*$)/);
                        options = dataValuesMatch
                            ? dataValuesMatch[1].split('|').map(value => ({ id: value, name: value }))
                            : [];
                    }

                    return (
                        <FormControl fullWidth
                            size="small"
                            error={!!errorMessage}
                        >
                            <InputLabel>{DisplayName}</InputLabel>
                            <Select
                                label={DisplayName}
                                onChange={(e) => handleField(fields.Sequence, e.target.value)}
                                value={fieldValues[fields.Sequence] || preSelectedValue}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            backgroundColor: '#fbe9e7',
                                            maxHeight: '200px',
                                            width: '200px',
                                        },
                                    },
                                }}
                                error={!!errorMessage}
                                disabled={!IsEdit}
                            >
                                {!IsCompulsory && <MenuItem key={0} value="">Select</MenuItem>}
                                {options.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {option.name}
                                    </MenuItem>
                                ))}
                            </Select>
                            {errorMessage && <FormHelperText style={{ color: 'red' }}>
                                {errorMessage}
                            </FormHelperText>}
                        </FormControl>
                    );
                }
            case 4: // Radio Button
                {
                    let radioOptions = [];
                    const defaultRadioValue = preSelectedValue || 'No';

                    if (fields.DataValues) {
                        const cleanedDataValues = dataValues
                            .replace(/[{}]/g, '')
                            .split(',')
                            .map(option => option.trim())
                            .filter(option => option.length > 0);

                        cleanedDataValues.forEach(option => {
                            if (option.includes('No')) radioOptions.push('No');
                            if (option.includes('Yes')) radioOptions.push('Yes');
                            if (option === '[Yes|No]') radioOptions = ['Yes', 'No'];
                        });
                    }

                    return (
                        <FormControl component="fieldset" error={!!errorMessage}>
                            <FormLabel component="legend">{DisplayName}</FormLabel>
                            <RadioGroup
                                row
                                value={fieldValues[fields.Sequence] || defaultRadioValue}
                                onChange={(e) => handleField(fields.Sequence, e.target.value)}
                                sx={{ flexDirection: 'row' }}
                                disabled={!IsEdit}
                            >
                                {radioOptions.map((option, index) => (
                                    <FormControlLabel
                                        key={`${fields.QuestionId}-${index}`}
                                        value={option}
                                        control={<Radio />}
                                        label={option}
                                        sx={{ marginRight: 2 }}
                                    />
                                ))}
                            </RadioGroup>
                            {errorMessage && (
                                <FormHelperText style={{ color: 'red' }}>
                                    {errorMessage}
                                </FormHelperText>
                            )}
                        </FormControl>
                    );

                }
            case 5: // Checkbox
                {
                    const checkboxValue = fieldValues[fields.Sequence] ?? (preSelectedValue === 'true' || preSelectedValue === true);

                    return (
                        <FormControl error={!!errorMessage} component="fieldset">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={checkboxValue}
                                        onChange={(e) => handleField(fields.Sequence, e.target.checked)}
                                        color="primary"
                                        disabled={!IsEdit}
                                    />
                                }
                                label={DisplayName}
                            />
                            {errorMessage && (
                                <FormHelperText style={{ color: 'red' }}>
                                    {errorMessage}
                                </FormHelperText>
                            )}
                        </FormControl>

                    );

                }
            case 6: // CheckBoxList
                {
                    // Parse DataValues for checkbox options
                    let checkboxOptions = [];
                    const selectedValues = fieldValues[fields.Sequence] || preSelectedValue || '';

                    if (fields.DataValues) {
                        // Extract checkbox options from DataValues (e.g., "Id: 1, Name: Option1|Id: 2, Name: Option2")
                        const regex = /Id:\s*(\d+),\s*Name:\s*([\w\s]+)/g;
                        const matches = Array.from(dataValues.matchAll(regex));
                        checkboxOptions = matches.map(match => ({
                            id: parseInt(match[1], 10),
                            name: match[2],
                            isChecked: selectedValues.includes(match[2]) // Check if the option is pre-selected
                        }));
                    }

                    // Handle change event for checkbox list
                    const handleCheckboxChange = (optionName, isChecked) => {
                        const updatedValues = selectedValues.split(',').filter(v => v); // Split and filter empty values
                        if (isChecked) {
                            // Add to the selected values if checked
                            if (!updatedValues.includes(optionName)) {
                                updatedValues.push(optionName);
                            }
                        } else {
                            // Remove from the selected values if unchecked
                            const index = updatedValues.indexOf(optionName);
                            if (index > -1) {
                                updatedValues.splice(index, 1);
                            }
                        }

                        // Join updated values back to a comma-separated string
                        handleField(fields.Sequence, updatedValues.join(','));
                    };

                    return (
                        <FormControl
                            component="fieldset"
                            error={!!errorMessage} // Error state
                        >
                            <FormLabel component="legend">{DisplayName}</FormLabel>
                            <FormGroup>
                                {checkboxOptions.map((option) => (
                                    <FormControlLabel
                                        key={option.id}
                                        control={
                                            <Checkbox
                                                checked={selectedValues.split(',').includes(option.name)}
                                                onChange={(e) => handleCheckboxChange(option.name, e.target.checked)}
                                                color="primary"
                                                disabled={!IsEdit}
                                            />
                                        }
                                        label={option.name}
                                    />
                                ))}
                            </FormGroup>
                            {/* Error message */}
                            {errorMessage && (
                                <FormHelperText style={{ color: 'red' }}>
                                    {errorMessage}
                                </FormHelperText>
                            )}
                        </FormControl>
                    );
                }
            case 7: // Date Picker
                {
                    return (
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                label={DisplayName}
                                inputFormat="dd/MMM/yyyy"
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        size="small"
                                        error={!!errorMessage} // Single source of error
                                        helperText={errorMessage} // Use only this for error message
                                    />
                                )}
                                onChange={(date) => {
                                    // Format the date or set to null if invalid
                                    const formattedDate = date ? format(date, 'dd-MMM-yyyy') : null;
                                    handleField(fields.Sequence, formattedDate);

                                    // Validate the date when selected
                                    if (IsCompulsory && !formattedDate) {
                                        validationErrors[fields.Sequence] = 'This field is required.';
                                    } else {
                                        validationErrors[fields.Sequence] = ''; // Reset error
                                    }
                                }}
                                value={fieldValues[fields.Sequence] || preSelectedValue || null} // Default or system date
                                disabled={!IsEdit}
                            />
                        </LocalizationProvider>
                    );
                }
            case 8: // Textarea
                {
                    return (
                        <FormControl fullWidth margin="normal" error={!!errorMessage}>
                            <TextareaAutosize
                                placeholder={DisplayName}
                                minRows={3}
                                onChange={(e) => handleField(fields.Sequence, e.target.value)}
                                value={fieldValues[fields.Sequence] ?? preSelectedValue ?? ''}
                                disabled={!IsEdit}
                                style={{
                                    width: "100%",
                                    height: "75px",
                                    fontFamily: "Inter",
                                    fontSize: "12px",
                                    borderColor: errorMessage ? 'red' : '#c4c4c4', // Add red border if there's an error
                                    padding: '10px',
                                }}
                            />
                            {/* Display error message */}
                            {errorMessage && (
                                <FormHelperText style={{ color: 'red' }}>
                                    {errorMessage}
                                </FormHelperText>
                            )}
                        </FormControl>
                    );
                }
            case 9: {
                const currentValue =
                    fieldValues[fields.Sequence] !== undefined
                        ? fieldValues[fields.Sequence]
                        : preSelectedValue;

                const saplError = validationErrors?.[fields.Sequence] || "";

                return (
                    <div style={{ width: "100%" }}>
                        <TextAreaWithToolbar
                            value={currentValue ?? ""}
                            onChange={(val) => {
                                handleField(fields.Sequence, val);
                            }}
                            label={DisplayName}
                            errorMessage={saplError}
                            isEditable={IsEdit}
                            toolbarId={`toolbar-${fields.Sequence}`}
                        />
                    </div>
                );
            }
            //case 9: {
            //    const currentValue = fieldValues[fields.Sequence] ?? preSelectedValue ?? '';

            //    return (
            //        <TextAreaWithToolbar
            //            value={fieldValues[fields.Sequence] ?? preSelectedValue ?? ''}
            //            //  onChange={(val) => handleField(fields.Sequence, val)}
            //            onChange={(val) => {
            //                const cleaned = stripHtml(val);
            //                handleField(fields.Sequence, cleaned === "" ? "" : val);
            //            }}
            //            label={DisplayName}
            //            errorMessage={errorMessage}
            //            isEditable={IsEdit}
            //            toolbarId={`toolbar-${fields.Sequence}`}
            //        />

            //    );
            //}


            default:
                return null;
        }
    };

    const handleSelectFile = (event) => {
        const selectedFiles = Array.from(event.target.files);
        const imagesArray = selectedFiles.map((file) => URL.createObjectURL(file));

        setRequestFile((prevImages) => [...prevImages, ...selectedFiles]);
        setUploadedFiles((prev) => [...prev, ...selectedFiles]); // ✅ prev will now be safe
        setBase64Document((prevFiles) => [...prevFiles, ...imagesArray]);

        setValidationErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.files;
            return updatedErrors;
        });

        event.target.value = ""; // Clear file input
        console.log("selectedFiles", selectedFiles);
    };

    const handleDownload = (fileKey, index) => {
        if (fileKey) {
            const encodedKey = encodeURIComponent(fileKey);
            URLS.downloadServiceFile(encodedKey, { responseType: 'blob' })
                .then((response) => {
                    const url = response.request.responseURL;
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileKey.split('/').pop());
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    console.log(`Downloading: ${url}`);
                })
                .catch((error) => {
                    console.error('Download failed:', error);
                });
        } else {
            console.log('No fileKey provided for download.');
        }
    };

    const isReopen = selectedReopenRow?.row?.Reopen;

    useEffect(() => {
        if (isReopen === 1) {
            URLS.reopenValue({ Id: trackerMasterId })
                .then((response) => {
                    const data = response?.data;

                    if (Array.isArray(data) && data.length > 0) {
                        const prefill = {};
                        data.forEach((item) => {
                            const colName = item?.ColName;
                            const colValue = item?.ColValue;

                            if (colName && colValue !== undefined && colValue !== null && colValue !== "") {
                                prefill[colName] = colValue;
                            }
                        });
                        setReopenPrefill(prefill);
                    } else {
                        // clear or reset if data is invalid or empty
                        setReopenPrefill({});
                    }
                })
                .catch((error) => {
                    console.error("Failed to fetch reopen values:", error);
                    setReopenPrefill({});
                });
        } else {
            // clear when not reopen
            setReopenPrefill({});
        }
    }, [isReopen, trackerMasterId]);

    useEffect(() => {
        if (reopenPrefill && Object.keys(reopenPrefill).length > 0) {
            const updatedFields = { ...fieldValues };

            loadTrackerData.forEach(field => {
                const colName = field.ColumnName;
                const sequence = field.Sequence;

                // If reopen value exists for this column AND field is empty
                if (Object.prototype.hasOwnProperty.call(reopenPrefill, colName)) {
                    updatedFields[sequence] = reopenPrefill[colName];  // force override with reopenVal
                }
            });

            setFieldValues(updatedFields);
        }
    }, [reopenPrefill, loadTrackerData]);

    useEffect(() => {
        const fileKeys = Array.isArray(reopenModalData?.FileKeys)
            ? reopenModalData.FileKeys
            : [];

        console.log("Preselected FileKeys:", fileKeys);

        const filesArray = [];

        fileKeys.forEach((filePath) => {
            const fileName = filePath.split("/").pop()?.trim();

            if (fileName) {
                const preselectedFile = new File(
                    [],
                    fileName,
                    {
                        type: "application/octet-stream",
                    }
                );

                filesArray.push(preselectedFile);
            }
        });

        console.log("Preselected File objects:", filesArray);

        setRequestFile(filesArray);
        setUploadedFiles(fileKeys);

        const fileUrls = Array.isArray(reopenModalData?.FileUrl)
            ? reopenModalData.FileUrl
            : [];

        setBase64Document(fileUrls);
    }, [reopenModalData]);

    useEffect(() => {
        // setUserId(CurrentLoggedInUser.ExecutiveId);
        setIsLoading(true);

        const payload = { Id: trackerId ?? trackerMasterId };

        URLS.loadIssueTrackerData(payload)
            .then((response) => {

                setLoadTrackerData(response.data);
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);

                console.error("Error loading tracker data:");
            });
        URLS.getTrackerLagInterval(payload)
            .then((response) => {
                console.log("res", response)
                setLagInterval(response.data.DefaultLagDays)
            })
            .catch((error) => {
                console.error("Error loading tracker data:");
            });

    }, []);

    useEffect(() => {
        tmpCache.effectiveFromValue = effectiveFromValue;
        tmpCache.effectiveToValue = effectiveToValue;
        tmpCache.trackerMasterId = trackerMasterId;
        tmpCache.issueId = issueId;
        tmpCache.userId = userId;
        tmpCache.loadTrackerData = loadTrackerData;
        tmpCache.lagInterval = lagInterval
        tmpCache.lageIntervalddl = lageIntervalddl
        tmpCache.selectedLagIntervalddl = selectedLagIntervalddl
    }, [effectiveFromValue, effectiveToValue, trackerMasterId, issueId, userId, loadTrackerData, lagInterval, lageIntervalddl, selectedLagIntervalddl]);


    useEffect(() => {
        // Only call API if coming back from detail
        if (shouldReload && tmpCache.effectiveFromValue && tmpCache.effectiveToValue) {
            onFilterClick();
            shouldReload = false; // reset after using
        }
    }, []);

    useEffect(() => {
        // Clear temp cache when trackerId changes
        tmpCache.effectiveFromValue = null;
        tmpCache.effectiveToValue = null;
        tmpCache.trackerMasterId = trackerId;
        tmpCache.issueId = null;
        tmpCache.userId = null;
        tmpCache.loadTrackerData = null;
        tmpCache.lagInterval = null;
        tmpCache.lageIntervalddl = null;
        tmpCache.selectedLagIntervalddl = null;

        // Reset state too
        // Reset filters only, do not clear loadTrackerData (it will re-fetch for the new tracker)

        // setEffectiveFromValue(startOfMonth(new Date()));
        // setEffectiveToValue(endOfMonth(new Date()));
        setIssueId("");
        setLagInterval("");
        setLagIntervalddl("");
        setSelectedLagIntervalddl([]);
        setReports([]);
        setFilteredReports([]);
        setShowDDL(false);
        setColumns([]);

        // trigger loadTrackerData fetch for the new trackerId
        const payload = { Id: trackerId ?? trackerMasterId };
        URLS.loadIssueTrackerData(payload)
            .then((response) => {
                setLoadTrackerData(response.data);
            })
            .catch((error) => {
                console.error("Error loading tracker data:", error);
                setLoadTrackerData([]);
            });

        URLS.getTrackerLagInterval(payload)
            .then((response) => {
                setLagInterval(response.data.DefaultLagDays);
            })
            .catch((error) => {
                console.error("Error loading tracker lag interval:", error);
            });
        URLS.reopenValue({ Id: trackerMasterId })
            .then((response) => {
                console.log("setReopenValue", response.data)
                setReopenValue(response.data)
            })
            .catch((error) => {
                console.error("Error loading tracker lag interval: ", error)
            })

    }, [trackerId]);


    // useEffect(() => {
    //    setReports([]);
    //    setEffectiveFromValue(startOfMonth(new Date()));
    //    setEffectiveToValue(endOfMonth(new Date()));
    //    setFilteredReports([]);
    //    setShowDDL(false);
    // }, [location.key])
    console.log("loadTrackerData", filteredReports, loadTrackerData, reopenValue, validationErrors)

    return (
        <Page title="JJCore Incident Tracker  Listing">
            <Card>
                <Stack direction="column" m={1} spacing={2}>

                    <Stack direction="row" spacing={2}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                label="From Date"
                                inputFormat="dd/MMM/yyyy"
                                value={Moment(effectiveFromValue).format('DD-MMM-yyyy')}
                                onChange={handleEffFrom}
                                renderInput={(params) => <TextField fullWidth size="small" {...params} sx={{ flexGrow: 1 }} />}
                            />
                        </LocalizationProvider>

                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                label="To Date"
                                inputFormat="dd/MMM/yyyy"
                                value={Moment(effectiveToValue).format('DD-MMM-yyyy')}
                                onChange={handleEffTo}
                                renderInput={(params) => <TextField fullWidth size="small" {...params} sx={{ flexGrow: 1 }} />}
                            />
                        </LocalizationProvider>
                        <TextField
                            fullWidth
                            label="Lag Interval"
                            size="small"
                            value={lagInterval}
                            onChange={hanleLagInterval}
                        />
                        {showDDL && (
                            <FormControl
                                size="small"
                                fullWidth
                            >
                                <InputLabel InputLabelProps={{ style: { color: 'green', fontSize: '14px' } }} >Lag Interval</InputLabel>
                                <Select
                                    label="Lag Interval"
                                    size="small"
                                    value={lageIntervalddl}
                                    onChange={(e) => handleLagDDL(e.target.value)}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                backgroundColor: '#fbe9e7', // Set the background color here
                                                maxHeight: '200px',
                                                width: '200px',// Set the max height here
                                            }
                                        }
                                    }}
                                >
                                    <MenuItem key={0} value={""} onClick={() => handleLagDDL()} >Select</MenuItem>

                                    {selectedLagIntervalddl.map((product) => (
                                        <MenuItem key={product.Id} value={product.Range}>
                                            {`${product.Range} (${product.Count})`}
                                        </MenuItem>
                                    ))}
                                </Select>

                            </FormControl>
                        )}


                        <Stack direction="row" spacing={1} sx={{ flexGrow: 1 }}>
                            <Tooltip title="Filter">
                                <Button variant="contained" size="small" onClick={onFilterClick}>
                                    <Icon icon="ic:outline-filter-alt" width="25px" height="25px" />
                                </Button>
                            </Tooltip>

                            {allowAdd === true && (
                                <Tooltip title="Add New">
                                    <Button
                                        component={RouterLink}
                                        to="/dashboard/servicerequesttrackerdetailspage"
                                        variant="contained"
                                        size="small"
                                        state={{
                                            tracker: {
                                                Id: '',
                                                ControlType: ''
                                            },
                                            trackerMasterId,
                                            loadTrackerData,
                                            trackerName
                                        }}
                                    >
                                        <Icon icon="ic:baseline-plus" width="25px" height="25px" />
                                    </Button>
                                </Tooltip>
                            )}

                            <Tooltip title="Reset">
                                <Button variant="contained" size="small" onClick={handleReset}>
                                    <Icon icon="ic:twotone-restart-alt" width="25px" height="25px" />
                                </Button>
                            </Tooltip>
                        </Stack>
                    </Stack>
                </Stack>

                <Divider />

                <Modal
                    open={reopenModal}
                    onClose={handleReopenCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" textAlign="center">
                            Are you sure you want to Reopen this record?
                        </Typography>
                        <Stack justifyContent="center" spacing={2} mt={2} direction="row">
                            <Button onClick={handleConfirmReopen} variant="contained" >
                                Yes
                            </Button>
                            <Button onClick={handleReopenCloseModal} variant="outlined">
                                No
                            </Button>
                        </Stack>
                    </Box>
                </Modal>

                {/*<Modal*/}
                {/*    open={reopenConfirmModal}*/}
                {/*    onClose={handleReopenConfirmCloseModal}*/}
                {/*    aria-labelledby="modal-modal-title"*/}
                {/*    aria-describedby="modal-modal-description"*/}
                {/*>*/}
                {/*    <Box sx={style}>*/}

                {/*        <Grid container spacing={2} mt={1}>*/}
                {/*            {loadTrackerData*/}
                {/*                .filter((item) =>*/}
                {/*                    reopenValue.some(*/}
                {/*                        (reopenItem) =>*/}
                {/*                            reopenItem.ColName === item.ColumnName*/}
                {/*                    )*/}
                {/*                )*/}
                {/*                .map((item, index) => (*/}
                {/*                    [8, 9].includes(item.UIControlKeyId) ? (*/}
                {/*                        <Grid item xs={12} key={item.Id || index}>*/}
                {/*                            {renderField(item)}*/}
                {/*                        </Grid>*/}
                {/*                    ) : (*/}
                {/*                        <Grid item xs={4} key={item.Id || index}>*/}
                {/*                            {renderField(item)}*/}
                {/*                        </Grid>*/}
                {/*                    )*/}
                {/*                ))}*/}
                {/*        </Grid>*/}
                {/*        <Stack direction="row" alignItems="center" spacing={2}>*/}
                {/*            <Button*/}
                {/*                component="label"*/}
                {/*                variant="contained"*/}
                {/*                tabIndex={-1}*/}
                {/*                sx={{*/}
                {/*                    height: 25,*/}
                {/*                    width: 130,*/}
                {/*                    borderRadius: 1,*/}
                {/*                    fontWeight: 500,*/}
                {/*                    ":hover": { backgroundColor: "#9e9e9e" },*/}
                {/*                    backgroundColor: "#e0e0e0",*/}
                {/*                    color: "#212121",*/}
                {/*                    boxShadow: "none",*/}
                {/*                }}*/}
                {/*            >*/}
                {/*                Choose Files*/}
                {/*                <VisuallyHiddenInput type="file" onChange={(e) => handleSelectFile(e)} multiple />*/}
                {/*            </Button>*/}
                {/*            {validationErrors.files && (*/}
                {/*                <Typography variant="body2" color="error" sx={{ marginTop: 1 }}>*/}
                {/*                    {validationErrors.files}*/}
                {/*                </Typography>*/}
                {/*            )}*/}

                {/*            */}{/* {!validationErrors.files && ( */}
                {/*            <Stack*/}
                {/*                direction="row"*/}
                {/*                alignItems="center"*/}
                {/*                spacing={1}*/}
                {/*                flexWrap="wrap"*/}
                {/*                sx={{ maxWidth: 'calc(100% - 150px)' }}*/}
                {/*            >*/}
                {/*                {uploadedFiles?.map((fileItem, index) => {*/}
                {/*                    const isFileObject = fileItem instanceof File;*/}
                {/*                    const fileName = isFileObject*/}
                {/*                        ? fileItem.name*/}
                {/*                        : fileItem?.split('/').pop()?.trim().replace(/^\d+_/, '');*/}

                {/*                    return (*/}
                {/*                        <Stack*/}
                {/*                            key={index}*/}
                {/*                            direction="row"*/}
                {/*                            alignItems="center"*/}
                {/*                            sx={{*/}
                {/*                                backgroundColor: '#f5f5f5',*/}
                {/*                                borderRadius: 1,*/}
                {/*                                padding: '0 8px',*/}
                {/*                                marginRight: 1,*/}
                {/*                                maxWidth: 200,*/}
                {/*                                overflow: 'hidden',*/}
                {/*                            }}*/}
                {/*                        >*/}
                {/*                            <Tooltip title={fileName} >*/}
                {/*                                <a*/}
                {/*                                    href="#"*/}
                {/*                                    onClick={(e) => {*/}
                {/*                                        e.preventDefault();*/}
                {/*                                        if (isFileObject) {*/}
                {/*                                            const url = URL.createObjectURL(fileItem);*/}
                {/*                                            const link = document.createElement('a');*/}
                {/*                                            link.href = url;*/}
                {/*                                            link.setAttribute('download', fileItem.name);*/}
                {/*                                            document.body.appendChild(link);*/}
                {/*                                            link.click();*/}
                {/*                                            document.body.removeChild(link);*/}
                {/*                                            URL.revokeObjectURL(url);*/}
                {/*                                        } else {*/}
                {/*                                            handleDownload(fileItem); // fileItem is a string (FileKey)*/}
                {/*                                        }*/}
                {/*                                    }}*/}
                {/*                                    style={{*/}
                {/*                                        textDecoration: 'none',*/}
                {/*                                        color: '#1976d2',*/}
                {/*                                        fontSize: '14px',*/}
                {/*                                    }}*/}
                {/*                                >*/}
                {/*                                    <Typography variant="body2" noWrap sx={{ maxWidth: 150 }}>*/}
                {/*                                        {fileName}*/}
                {/*                                    </Typography>*/}
                {/*                                </a>*/}
                {/*                            </Tooltip>*/}
                {/*                            <IconButton*/}
                {/*                                size="small"*/}
                {/*                                onClick={() => {*/}
                {/*                                    const updated = [...uploadedFiles];*/}
                {/*                                    updated.splice(index, 1);*/}
                {/*                                    setUploadedFiles(updated);*/}
                {/*                                }}*/}
                {/*                                sx={{ padding: 0 }}*/}
                {/*                            >*/}
                {/*                                <Iconify icon="mdi:close" />*/}
                {/*                            </IconButton>*/}
                {/*                        </Stack>*/}
                {/*                    );*/}
                {/*                })}*/}

                {/*            </Stack>*/}


                {/*            */}{/* )} */}
                {/*        </Stack>*/}

                {/*        <Stack*/}
                {/*            justifyContent="center"*/}
                {/*            spacing={2}*/}
                {/*            mt={2}*/}
                {/*            direction="row"*/}
                {/*        >*/}
                {/*            <Button*/}
                {/*                onClick={handleReopen}*/}
                {/*                variant="contained"*/}
                {/*            >*/}
                {/*                Yes*/}
                {/*            </Button>*/}

                {/*            <Button*/}
                {/*                onClick={handleReopenConfirmCloseModal}*/}
                {/*                variant="outlined"*/}
                {/*            >*/}
                {/*                No*/}
                {/*            </Button>*/}
                {/*        </Stack>*/}
                {/*    </Box>*/}
                {/*</Modal>*/}

                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" textAlign="center">
                            Are you sure you want to delete this record?
                        </Typography>
                        <Stack justifyContent="center" spacing={2} mt={2} direction="row">
                            <Button onClick={handleConfirmDelete} variant="contained">
                                Yes
                            </Button>
                            <Button onClick={handleClose} variant="outlined" >
                                No
                            </Button>
                        </Stack>
                    </Box>
                </Modal>

                <Modal open={historyOpen} onClose={handleHistoryClose}>
                    <Box sx={{ ...modalStyle, position: 'relative', p: 2 }}>
                        {/* Close button */}
                        <IconButton
                            onClick={handleHistoryClose}
                            sx={{ position: 'absolute', top: 10, right: 10, color: 'grey', zIndex: 10, }}
                        >
                            <CloseIcon />
                        </IconButton>

                        {/* Tabs */}
                        <Tabs
                            value={tabValue}
                            onChange={handleTabChange}
                            sx={{
                                mb: 2,
                                "& .MuiTabs-indicator": {
                                    backgroundColor: "#3C97FF",
                                    height: "3px",
                                    borderRadius: "3px",
                                },
                            }}
                        >
                            <Tab
                                label="History"
                                sx={{
                                    textTransform: "none",
                                    fontWeight: tabValue === 0 ? "600" : "500",
                                    color: tabValue === 0 ? "#121212" : "#7B7B7B",
                                    fontSize: "14px",
                                }}
                            />
                            {linkedIncidentId &&
                                <Tab
                                    label="Linked Incident History"
                                    sx={{
                                        textTransform: "none",
                                        fontWeight: tabValue === 1 ? "600" : "500",
                                        color: tabValue === 1 ? "#121212" : "#7B7B7B",
                                        fontSize: "14px",
                                    }}
                                />
                            }
                        </Tabs>

                        {/* Tab Content */}
                        {tabValue === 0 && (
                            <Box>
                                {/* <Typography variant="h5" mb={1}> */}
                                {/*    History */}
                                {/* </Typography> */}
                                {isLoading && <LoadingProgressBar sx={{ py: 6 }} />}
                                {!isLoading && historyData?.length > 0 ? (
                                    <div style={{ height: '60vh' }}>
                                        <DataGrid
                                            rows={historyData}
                                            columns={historyGridData}
                                            getRowId={(row) => historyData.indexOf(row)}
                                            getRowHeight={() => 'auto'}
                                            density="compact"
                                            disableSelectionOnClick
                                            disableColumnMenu
                                            rowsPerPageOptions={[25, 50, 100]}
                                            pageSize={pageSize2}
                                            onPageSizeChange={(newPageSize) => setPageSize2(newPageSize)}
                                            sx={{
                                                '& .MuiDataGrid-columnHeaderTitle': { wordWrap: 'break-word', lineHeight: 1.2 },
                                                '& .MuiDataGrid-root': { border: '1px solid rgba(224,224,224,1)' },
                                                '& .MuiDataGrid-cell': { borderBottom: '1px solid rgba(224,224,224,1)' },
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <Typography>No History Found.</Typography>
                                )}
                            </Box>
                        )}

                        {tabValue === 1 && linkedIncidentId && (
                            <Box>
                                {/* <Typography variant="h5" mb={1}> */}
                                {/*    Linked Incident Tracker */}
                                {/* </Typography> */}
                                {isLoading && <LoadingProgressBar sx={{ py: 6 }} />}
                                {!isLoading && linkedHistoryData?.length > 0 ? (
                                    <div style={{ height: '60vh' }}>
                                        <DataGrid
                                            rows={linkedHistoryData}
                                            columns={linkedHitoryColumn}
                                            getRowId={(row) => linkedHistoryData.indexOf(row)}
                                            getRowHeight={() => 'auto'}
                                            density="compact"
                                            disableSelectionOnClick
                                            disableColumnMenu
                                            rowsPerPageOptions={[25, 50, 100]}
                                            pageSize={pageSize2}
                                            onPageSizeChange={(newPageSize) => setPageSize2(newPageSize)}
                                            sx={{
                                                '& .MuiDataGrid-columnHeaderTitle': { wordWrap: 'break-word', lineHeight: 1.2 },
                                                '& .MuiDataGrid-root': { border: '1px solid rgba(224,224,224,1)' },
                                                '& .MuiDataGrid-cell': { borderBottom: '1px solid rgba(224,224,224,1)' },
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <Typography>No Linked Incidents Found.</Typography>
                                )}
                            </Box>
                        )}
                    </Box>
                </Modal>
                <Modal open={documentHistoryOpen} onClose={handleDocumentHistoryClose}>
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: '60%',
                            bgcolor: 'background.paper',
                            boxShadow: 24,
                            // maxHeight: '80vh',
                            overflow: 'auto',
                            borderRadius: '8px',
                        }}
                    >

                        {/* Close button */}

                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '0px 16px',
                                borderBottom: '1px solid #E0E0E0',
                                backgroundColor: '#fff',
                                m: 0, // remove outer margins
                            }}
                        >
                            <Typography variant="h6" fontWeight='500'>
                                Document History
                            </Typography>

                            <IconButton
                                onClick={handleDocumentHistoryClose}
                                sx={{
                                    color: 'grey',
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>

                        {/* Tab Content */}
                        <Box sx={{ p: 1 }}>
                            {/* <Typography variant="h5" mb={1}> */}
                            {/*    History */}
                            {/* </Typography> */}
                            {isLoading && <LoadingProgressBar sx={{ py: 6 }} />}
                            {!isLoading && documentHistoryData?.length > 0 ? (
                                <div style={{ height: '60vh' }}>
                                    <DataGrid
                                        rows={documentHistoryData}
                                        columns={documentHistoryGridData}
                                        getRowId={(row) => documentHistoryData.indexOf(row)}
                                        getRowHeight={() => 'auto'}
                                        density="compact"
                                        disableSelectionOnClick
                                        disableColumnMenu
                                        rowsPerPageOptions={[25, 50, 100]}
                                        pageSize={pageSize2}
                                        onPageSizeChange={(newPageSize) => setPageSize2(newPageSize)}
                                        sx={{
                                            '& .MuiDataGrid-columnHeaderTitle': { wordWrap: 'break-word', lineHeight: 1.2 },
                                            '& .MuiDataGrid-root': { border: '1px solid rgba(224,224,224,1)' },
                                            '& .MuiDataGrid-cell': { borderBottom: '1px solid rgba(224,224,224,1)' },
                                        }}
                                    />
                                </div>
                            ) : (
                                <Typography>No Document History Found.</Typography>
                            )}
                        </Box>

                    </Box>
                </Modal>

                <div style={{ height: '70vh', width: '100%' }}>
                    <CustomDataGrid
                        rows={filteredReports}
                        columns={columns}
                        pageSizeOptions={[25, 50, 100]}
                        defaultPageSize={25}
                        onExportClick={onExportClick}

                    />

                </div>

            </Card>

            {isLoading && (<LoadingProgressBar sx={{ py: 6 }} />)}
        </Page>
    );


}